export const initialAoiState = {
  selection: {
    category: null,
    selectedIds: [],
  },
  overlay: null,
};

export const aoiCategories = [
  // example
  // {
  //     name: "AOI category display Name",
  //     descriptionField: field in AOI geojson with more descriptive feature name
  //                    (e.g. huc2_region_name) for displaying in AOI selection dropdown
  //     id,
  //     data: data,
  //     dataFieldName: "name_in_dataset"
  // },
  {
    name: "NGWOS Basin",
    shortName: "NGWOS",
    id: "ngwos-basin",
    data: "ngwosBasins",
    dataFieldName: "ngwos_basin",
  },
  // {
  //   name: "IWAAS Basin",
  //   shortName: "IWAAS",
  //   id: "iwaas-basin",
  //   data: "iwaasBasins",
  //   dataFieldName: "iwaas_basin",
  // },
];